import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import SEOArticleSection from './components/SEOArticleSection';
import ArticleCards from './components/ArticleCards';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <CategoryGrid />
      <CTASection />
      <SEOArticleSection />
      <ArticleCards />
      <Testimonials />
      <Footer />
    </main>
  );
}